<template>
  <v-app id="inspire" v-if="load">
    <v-main>
      <v-container class="fill-height pa-0"
                   fluid
                   :style="`background-image: url('${backgroundImage}'); background-position: center center; background-size: cover; `">
        <v-col offset-sm="1" sm="10">
          <v-row>
            <v-col align-lg-self="end" cols="12" offset-sm="2" offset-md="3" offset-lg="0" sm="8" md="6" lg="4">
              <v-scroll-x-reverse-transition mode="out-in">
                <v-card class="elevation-12" key="b" :color="color">
                  <v-col class="d-flex justify-center">
                    <v-avatar size="200" max-height="100px" tile>
                      <v-img :src="logoImage" height="100%" contain />
                    </v-avatar>
                  </v-col>
                  <v-card-text>
                    <core-form v-if="load && empresas.length > 0" :submit="login">
                      <v-col class="mt-5 mb-10">
                        <input-select label="Empresa"
                                      required
                                      v-model="credentials.empresa"
                                      :options="empresas"></input-select>
                      </v-col>
                      <v-col class="pt-0 pb-10">
                        <v-btn @click="logout" class="mr-4">
                          <i class="fas fa-arrow-left mr-2"></i> Sair
                        </v-btn>
                        <v-btn type="submit" color="primary"> Entrar </v-btn>
                      </v-col>
                    </core-form>
                    <v-row v-else-if="empresasCarregadas && !error">
                      <v-col class="pt-0 pb-10">
                        <v-alert type="warning">O usuário informado não possui acesso a essa aplicação</v-alert>
                        <v-btn @click="logout" color="primary" block>
                          <i class="fas fa-arrow-left mr-2"></i> Tentar com outro usuário
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row v-else-if="error">
                      <v-col class="pt-0 pb-10">
                        <v-alert type="warning">Não foi possível realizar login</v-alert>
                        <v-btn @click="logout" color="primary" block>
                          <i class="fas fa-arrow-left mr-2"></i> sair e tentar novamente
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-scroll-x-reverse-transition>
            </v-col>
          </v-row>
        </v-col>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'login',
  metaInfo: {
    title: window.env.VUE_APP_NOME + ' - Login'
  },
  data () {
    return {
      logoImage: this.$theme.logo || 'assets/imgs/logo.png',
      backgroundImage: this.$theme.background || 'assets/imgs/background.png',
      credentials: {
        email: '',
        password: ''
      },
      step: 1,
      error: false,
      empresas: [],
      empresasCarregadas: false,
      load: false
    }
  },
  methods: {
    login () {
      const th = this

      const dto = {
        codigoEmpresa: th.credentials.empresa,
        refreshToken: th.$user.refreshToken
      }
      th.$api.Autenticacao.AutenticarEmpresa(dto).then(function (response) {
        if (th.$api.UI.PostLoadData(response, true)) {
          const user = th.$api.UTIL.Auth.RegisterToken(response, th.$user.identificador)
          if (user) {
            th.$store.dispatch('setUserData', { user })
            if (th.$empresa && th.$empresa.codigo !== th.credentials.empresa) {
              th.$api.Empresa.GetByIdToParceiro(th.credentials.empresa).then(function (empresa) {
                if (th.$api.UI.PostLoadData(empresa, true)) {
                  localStorage.setItem('empresa', JSON.stringify(empresa))
                  location.href = '/'
                }
              })
            }
          }
        } else {
          th.load = true
          th.error = true
        }
      })
    },
    logout () {
      const th = this
      const user = this.$store.getters.user
      th.$api.Autenticacao.Logout(user.documento, user.refreshToken)
        .then(function (data) {
          if (th.$api.UI.PostLoadData(data)) {
            th.$store.commit('CLEAR_USER_DATA')
          }
        })
        .catch((err) => console.log(err))
    },
  },
  computed: {
    color: function () {
      return this.$theme.dark ? '#0000007A' : '#FFFFFFCA'
    }
  },
  created () {
    const th = this
    if (localStorage.status === 'loggedOut') {
      th.$router.push('/')
    } else if (th.$empresa && th.$empresa.codigo && th.$empresa.codigo !== th.global.GuidEmpty) {
      th.credentials.empresa = th.$empresa.codigo

      if (!th.$user) { th.login() } else { location.href = '/' }
      return
    }

    th.empresas = []
    th.$api.Empresa.GetAllByUsuario(th.$user.email).then(function (response) {
      if (response) {
        if (response.length === 1) {
          th.credentials.empresa = response[0].codigo
          th.login()
        } else {
          th.empresas = response.map((o) => { return { value: o.codigo, text: o.nome } })
          th.empresasCarregadas = true
          th.load = true
        }
      }
    })
    th.empresasCarregadas = true
  }
}
</script>
